module.exports = __webpack_public_path__ + "img/top_left.989eecc5.svg";